import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { userAgreementIndexRoute, userAgreementRoute } from '@/root-app/app-routes/routes';
import RootApp from '@/root-app/RootApp';
import { ROUTE_NAMES, withRoot } from '@/core/routes/routeNames';
import RoutingErrorPage from '@/components/Error/RoutingErrorPage';

const UserAgreementRoutes: RouteObject = {
  path: ROUTE_NAMES.ROOT,
  Component: RootApp,
  handle: {
    isFullPage: true,
  },
  errorElement: <RoutingErrorPage />,
  children: [
    userAgreementIndexRoute,
    userAgreementRoute,
    {
      path: ROUTE_NAMES.NOT_FOUND,
      handle: {
        isFullPage: true,
      },
      element: <Navigate to={`${withRoot(ROUTE_NAMES.USER_AGREEMENT.ROOT)}?isFromAuth=true`} />,
    },
  ],
};

export default UserAgreementRoutes;
